import { render, staticRenderFns } from "./ImportClientsContainer.vue?vue&type=template&id=6db1764c&scoped=true&"
import script from "./ImportClientsContainer.vue?vue&type=script&lang=js&"
export * from "./ImportClientsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db1764c",
  null
  
)

export default component.exports